import React, { useEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import {
  Button,
  Grid,
  TextField,
  Typography,
  makeStyles,
} from "@material-ui/core";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import editorConfiguration from "../../../../util/EditorConfiguration";
import Editor from "ckeditor5-custom-build/build/ckeditor";
import apiHelper from "../../../../util/ApiHelper";
import { useLoading } from "../../../../util/LoadingProvider";
import { toast } from "react-toastify";

const useStyles = makeStyles({
  input: {
    width: "100%",
    marginTop: "10px",
    marginBottom: "40px",
    "& button": {
      fontSize: "13px",
      lineHeight: "15px",
      width: "25%",
    },
  },
});

export default function EmailForm(props) {
  const { disabled, entryId, setOpen } = props;
  const [defaultValue, setDefaultValue] = React.useState({
    subject: "",
    content: "",
  });
  const { control, reset, handleSubmit } = useForm({
    defaultValues: React.useMemo(() => defaultValue, [defaultValue]),
  });

  const { setLoading } = useLoading();

  const sendApplicationEmail = async (id, req) => {
    try {
      setLoading(true);
      const result = await apiHelper.hkiff.sendApplicationEmail(id, req);
      if (result.data.code === 0) {
        toast.dark("Application email has been sent.");
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const getPrefilledEmailTemplate = async () => {
    try {
      const template = await apiHelper.hkiff.getPrefillTemplate(entryId);
      const { data } = template;
      setDefaultValue(data);
      reset(data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getPrefilledEmailTemplate();
  }, []);

  const onSubmit = async (values) => {
    try {
      await sendApplicationEmail(entryId, values);
      setOpen(false);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <Grid container>
        <Grid item xs={12}>
          <Typography
            variant="span"
            gutterBottom
            style={{ fontWeight: "bold" }}
          >
            Email Language
          </Typography>
        </Grid>
      </Grid>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Grid container direction="column" spacing={3}>
          <Grid item xs={12}>
            <Controller
              control={control}
              name="subject"
              rules={{ required: "Required" }}
              render={({ field, fieldState: { error } }) => (
                <TextField
                  fullWidth
                  margin="dense"
                  label="Subject title"
                  variant="outlined"
                  error={!!error}
                  helperText={error ? error.message : null}
                  {...field}
                />
              )}
            />
          </Grid>
          <Grid container item xs={12}>
            <Grid item>
              <Typography
                variant="span"
                gutterBottom
                style={{ fontWeight: "bold" }}
              >
                Email Content
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Controller
                name="content"
                control={control}
                render={({ field, fieldState: { error } }) => (
                  <CKEditor
                    editor={Editor}
                    config={editorConfiguration}
                    data={field.value}
                    disabled={disabled}
                    onChange={(event, editor) => {
                      const data = editor.getData();
                      field.onChange(data);
                    }}
                  />
                )}
              />
            </Grid>
          </Grid>
          <Grid
            container
            display="flex"
            alignItems="center"
            justify="flex-end"
            style={{ marginTop: "30px" }}
          >
            <Button
              type="button"
              variant="string"
              disableElevation
              style={{
                color: "#306F9D",
                marginRight: "5px",
                padding: "9px 16px",
              }}
              onClick={() => setOpen(false)}
            >
              Cancel
            </Button>
            <Button
              type="submit"
              variant="contained"
              disableElevation
              style={{
                color: "white",
                background: "#306F9D",
                marginRight: "5px",
                padding: "9px 16px",
              }}
            >
              Send
            </Button>
          </Grid>
        </Grid>
      </form>
    </>
  );
}
